/* eslint-disable no-unused-vars */
/* eslint-disable no-return-assign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable eqeqeq */
/* eslint-disable no-unsafe-optional-chaining */
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Tag,
  Typography
} from 'antd';
import {
  CardWrapper,
  MetaWrapper,
  renderTabBarPayment
} from 'components/MarkupAndBaseRateStyledWrapper/MarkupAndBaseRateStyledWrapper';
import CommissionCalculator from 'components/CommissionCalculator';
import merchantAPI from 'services/merchants';
import { useSelector } from 'react-redux';
import Alert from 'components/Alert';
import styled from 'styled-components';
import {
  BASE_RATE,
  BASE_RATE_TYPE,
  COMMERCIAL_TYPE,
  COMMISSION_TYPE,
  DIFFERENTIAL,
  DROPDOWN,
  FIRST,
  FLAT,
  FLAT_FEE,
  formatPaymentMode,
  IS_ENABLE,
  MAX_AMOUNT,
  MERCHANT_COMMERCIAL,
  MIN_AMOUNT,
  PaymentModeTabs,
  PERCENTAGE,
  PERCENTAGE_SIGN,
  PRIMARY,
  RUPPEE_SIGN,
  SWITCH
} from './const';
import './MerchantDetails.scss';
import { customExpandIcon, commericalFields } from './ProductFields/const';
import CommercialActions from './CommercialActions';

const ModalWrapper = styled(Modal)`
  .ant-modal-close {
    top: 10px;
    right: 10px;
  }
  .ant-modal-close-x {
    font-size: 16px;
  }
`;

function ProductTemplate({ product, configuration, initial }) {
  const user = useSelector((state) => state?.user);
  const isRequestMarkupAllowed = useSelector(
    (state) => state.user.planPermissions?.can_request_markup
  );
  const [raiseRequest, setRaiseRequest] = useState(false);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const submerchantId = searchParams.get('submerchant');
  const referralSource = searchParams.get('app');
  const [changedSlabLength, setChangedSlabLength] = useState(0);
  const [commercialForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [commissionModalOpen, setCommissionModalOpen] = useState(false);
  const [toggleDisableField, setToggleDisableField] = useState(true);
  const [confirmRevisisionModal, setConfirmRevisisionModal] = useState(false);
  const [transactionAmountForm] = Form.useForm();
  const changedSlabsRef = useRef([]);
  const handleCommissionCalculatorModal = () => {
    setCommissionModalOpen(!commissionModalOpen);
    transactionAmountForm.setFieldValue('formTransactionAmount', 1000);
  };
  const [configsItems, setConfigsItems] = useState();
  const { Panel } = Collapse;
  const { Option } = Select;

  const handleRequestChange = () => {
    changedSlabsRef.current = [];
    commercialForm.resetFields();
    setToggleDisableField(!toggleDisableField);
  };
  const hanldeRevisionModal = () => {
    setConfirmRevisisionModal(!confirmRevisisionModal);
  };
  const hanldeOnCancelRequest = () => {
    changedSlabsRef.current = [];
    handleRequestChange();
    hanldeRevisionModal();
  };
  const handleRaiseRequestModal = (state) => {
    setRaiseRequest(state);
  };

  const handleFormSubmit = async (event) => {
    setLoading(true);
    const response = await merchantAPI.markupConfigSubmit({
      ...changedSlabsRef.current,
      merchant_id: Number(id),
      submerchant_id: submerchantId,
      referral_source: parseInt(referralSource, 10),
      product_name: product
    });
    if (!response.success) {
      Alert('Something went wrong', response?.message, 'error');
      setLoading(false);
      setConfirmRevisisionModal(false);
      return;
    }
    hanldeOnCancelRequest();
    setRaiseRequest(true);
    setLoading(false);
  };
  const ensurePath = (obj, path, defaultValue = {}) =>
    path.reduce((acc, key) => (acc[key] ??= {}), obj);

  const getWarning = (slab, field, hasWarning) => {
    if (!hasWarning) return '';

    switch (field?.type) {
      case SWITCH:
        return field?.warningText;
      case DROPDOWN:
        return `${field?.warningText}: ${
          slab[field?.key] === PERCENTAGE ? PERCENTAGE_SIGN : RUPPEE_SIGN
        }`;
      default:
        return `${field?.warningText}: ${slab?.[field?.key]}`;
    }
  };

  const getPrefix = (fieldKey, slab, fieldPath) => {
    if (fieldKey === FLAT_FEE)
      return <div className={`${toggleDisableField ? 'grey-text' : 'black-text'}`}>₹</div>;
    const typeMap = {
      merchant_commercial: COMMERCIAL_TYPE,
      commercial_value: COMMERCIAL_TYPE,
      partner_commission: COMMISSION_TYPE,
      base_rate_value: BASE_RATE_TYPE
    };
    const getTypeValue = (field) => slab?.[typeMap[field]];
    const getFieldKey = (field) => typeMap[field];

    const slabKey = getTypeValue(fieldKey);

    if (!slabKey) return null;
    const [productName, modeType, categoryKey, typeKey, cardBrand, key] = fieldPath;

    const shouldDisable = [BASE_RATE].includes(categoryKey) ? true : toggleDisableField;

    return (
      <div
        style={{
          height: '29px'
        }}
      >
        <Form.Item
          shouldUpdate={(prev, next) => {
            return (
              prev != next &&
              prev?.[productName]?.[modeType]?.[categoryKey]?.[typeKey]?.[cardBrand]?.[key]?.[
                getFieldKey(fieldKey)
              ] !=
                next?.[productName]?.[modeType]?.[categoryKey]?.[typeKey]?.[cardBrand]?.[key]?.[
                  getFieldKey(fieldKey)
                ]
            );
          }}
        >
          {() => {
            const value = commercialForm.getFieldValue([
              productName,
              modeType,
              categoryKey,
              typeKey,
              cardBrand,
              key,
              getFieldKey(fieldKey)
            ]);
            const hasWarning = value !== undefined && value !== slab?.[getFieldKey(fieldKey)];

            return (
              <Space.Compact>
                <Form.Item
                  validateStatus={hasWarning ? 'warning' : ''}
                  help={getWarning(
                    slab,
                    { type: DROPDOWN, warningText: 'Old', key: getFieldKey(fieldKey) },
                    hasWarning
                  )}
                  name={[
                    productName,
                    modeType,
                    categoryKey,
                    typeKey,
                    cardBrand,
                    key,
                    getFieldKey(fieldKey)
                  ]}
                >
                  <Select
                    size="small"
                    className={`${hasWarning ? 'custom-warning-select' : ''}`}
                    style={{
                      width: 70,
                      marginBottom: '-1px'
                    }}
                    defaultValue={slabKey}
                    disabled={shouldDisable}
                  >
                    <Option value={PERCENTAGE} key={`${fieldKey}-1`}>
                      %
                    </Option>
                    <Option value={FLAT} key={`${fieldKey}-2`}>
                      ₹
                    </Option>
                  </Select>
                </Form.Item>
              </Space.Compact>
            );
          }}
        </Form.Item>
      </div>
    );
  };
  const renderInputComponent = (field, slab, categoryKey, hasWarning, fieldPath) => {
    const shouldDisable = [BASE_RATE].includes(categoryKey)
      ? true
      : (![MAX_AMOUNT, MIN_AMOUNT].includes(field?.key) ? toggleDisableField : true) &&
        field?.disable;
    switch (field?.type) {
      case SWITCH:
        return <Switch disabled={shouldDisable} defaultChecked={slab?.[field?.key]} />;
      default:
        return (
          <InputNumber
            size="middle"
            className={`${hasWarning ? 'custom-warning' : ''} ${
              shouldDisable ? 'grey-text' : 'black-text'
            }`}
            disabled={shouldDisable}
            defaultValue={slab?.[field?.key]}
            addonAfter={getPrefix(field?.key, slab, fieldPath)}
            style={{ width: '100%' }}
          />
        );
    }
  };

  // Helper to render individual fields
  const renderFormRow = (
    productName,
    modeType,
    typeKey,
    categoryKey,
    slab,
    key,
    fields,
    cardBrand
  ) => (
    <Row key={key} justify="space-between">
      {fields.map((field) => (
        <Col span={field?.span || commericalFields[productName]?.span}>
          <Form.Item
            noStyle
            shouldUpdate={(prev, next) => {
              return (
                prev != next &&
                prev?.[productName]?.[modeType]?.[categoryKey]?.[typeKey]?.[cardBrand]?.[key]?.[
                  field?.key
                ] !=
                  next?.[productName]?.[modeType]?.[categoryKey]?.[typeKey]?.[cardBrand]?.[key]?.[
                    field?.key
                  ]
              );
            }}
          >
            {() => {
              const fieldPath = [
                productName,
                modeType,
                categoryKey,
                typeKey,
                cardBrand,
                key,
                field?.key
              ];
              const value = commercialForm.getFieldValue(fieldPath);
              const hasWarning = value !== undefined && value !== slab?.[field?.key];

              return (
                <Form.Item
                  name={fieldPath}
                  label={
                    <span>
                      {field?.label} {field?.toolTip}
                    </span>
                  }
                  validateStatus={hasWarning ? 'warning' : ''}
                  help={getWarning(slab, field, hasWarning)}
                  initialValue={slab?.[field?.key]}
                  style={{
                    color: '#2A2A2A',
                    fontSize: '12px',
                    fontWeight: 30
                  }}
                  tooltip={field?.toolTip}
                  labelCol={{ span: 24 }}
                  className="mb-0"
                  {...(field?.type === SWITCH && {
                    valuePropName: 'checked',
                    getValueFromEvent: (checked) => (checked ? 1 : 0)
                  })}
                >
                  {renderInputComponent(field, slab, categoryKey, hasWarning, fieldPath)}
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      ))}
    </Row>
  );

  // Helper for 'differential' type
  const renderDifferential = (
    productName,
    modeType,
    typeKey,
    type,
    differentialLabel,
    categoryKey
  ) =>
    Object.entries(type).map(([cardBrand, brandSlab]) => {
      if (cardBrand === 'label') return null;
      return (
        <div>
          <div style={{ display: 'flex', padding: '6px 0', gap: '15px', alignItems: 'center' }}>
            <Typography>{differentialLabel}</Typography>
            <Tag color="blue" style={{ padding: '5px' }}>
              {cardBrand}
            </Tag>
          </div>
          {Object.entries(brandSlab).map(([key, slab]) =>
            renderFormRow(
              productName,
              modeType,
              typeKey,
              categoryKey,
              slab,
              key,
              commericalFields[product]?.[categoryKey]?.[typeKey] || [],
              cardBrand
            )
          )}
        </div>
      );
    });

  // Collapse Panel Renderer
  const renderCategoryCollapse = (
    productName,
    modeType,
    typeKey,
    type,
    categoryKey,
    differentialLabel
  ) => {
    const isPrimary = typeKey === PRIMARY;
    const isDifferential = typeKey === DIFFERENTIAL;
    return (
      <Collapse
        size="large"
        key={typeKey}
        style={{ backgroundColor: '#FFFFFF' }}
        expandIcon={customExpandIcon}
        expandIconPosition="end"
        collapsible={
          (isDifferential && Object.keys(type || {}).length === 1) ||
          (isPrimary && Object.keys(type || {}).length === 0)
            ? 'disabled'
            : undefined
        }
        defaultActiveKey={isPrimary && Object.keys(type || {}).length !== 0 ? [PRIMARY] : undefined}
      >
        <Collapse.Panel
          header={typeKey}
          key={typeKey}
          style={{
            textTransform: 'capitalize',
            paddingLeft: 0,
            paddingRight: 0,
            fontSize: '15px',
            fontWeight: 500
          }}
        >
          {isPrimary &&
            Object.entries(type).map(([key, slab]) =>
              renderFormRow(
                productName,
                modeType,
                typeKey,
                categoryKey,
                slab,
                key,
                commericalFields[product]?.[categoryKey]?.[typeKey] || [],
                FIRST
              )
            )}
          {isDifferential &&
            renderDifferential(
              productName,
              modeType,
              typeKey,
              type,
              differentialLabel,
              categoryKey
            )}
        </Collapse.Panel>
      </Collapse>
    );
  };

  useEffect(() => {
    const productConfigItems = Object.entries(initial || {}).map(([modeType, config], ind) => ({
      key: ind,
      label: config?.default?.label || formatPaymentMode(modeType),
      children: (
        <Row gutter={[8, 32]} style={{ marginTop: 12 }}>
          {Object.entries(config || {}).map(([categoryKey, category]) => {
            if (categoryKey === IS_ENABLE) {
              return (
                <div
                  style={{
                    display: 'flex',
                    fontSize: '18px',
                    marginBottom: '2px',
                    fontWeight: 500,
                    gap: '10px',
                    alignItems: 'flex-start'
                  }}
                >
                  <Typography key={modeType}>{formatPaymentMode(modeType)}</Typography>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, next) => {
                      return (
                        prev != next &&
                        prev?.[product]?.[modeType]?.[categoryKey] !=
                          next?.[product]?.[modeType]?.[categoryKey]
                      );
                    }}
                  >
                    {() => {
                      const fieldPath = [product, modeType, categoryKey];
                      const value = commercialForm.getFieldValue(fieldPath);
                      const hasWarning = value !== undefined && value !== category;
                      return (
                        <Form.Item
                          name={fieldPath}
                          validateStatus={hasWarning ? 'warning' : ''}
                          help={getWarning(
                            'sample',
                            { type: SWITCH, warningText: 'Flag change' },
                            hasWarning
                          )}
                          style={{ marginBottom: '22px', marginRight: '40px' }}
                          initialValue={category}
                        >
                          <Switch disabled={toggleDisableField} defaultChecked={category} />
                        </Form.Item>
                      );
                    }}
                  </Form.Item>
                </div>
              );
            }

            return (
              <Col span={24}>
                <Card
                  style={{
                    padding: '2%',
                    backgroundColor: '#FBF9FF'
                  }}
                >
                  <Row gutter={[0, 16]}>
                    {Object.entries(category).map(([typeKey, type]) => {
                      if (typeKey === 'label') {
                        return (
                          <Typography
                            key={typeKey}
                            style={{
                              color: '#2A2A2A',
                              marginLeft: '3px',
                              fontWeight: 500,
                              fontSize: 16
                            }}
                          >
                            {type}
                          </Typography>
                        );
                      }

                      const differentialLabel = category?.differential?.label;

                      return (
                        <Col span={24}>
                          <Card>
                            {renderCategoryCollapse(
                              product,
                              modeType,
                              typeKey,
                              type,
                              categoryKey,
                              differentialLabel
                            )}
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                </Card>
              </Col>
            );
          })}
        </Row>
      )
    }));
    setConfigsItems(productConfigItems);
  }, [product, toggleDisableField]);
  const handleFormChange = (changedValues, allValues) => {
    const findChangedSlabs = (obj, path = []) => {
      Object.entries(obj).forEach(([key, val]) => {
        if (typeof val === 'object' && val !== null) {
          findChangedSlabs(val, [...path, key]);
          return;
        }
        if (path.length === 2) {
          const [productName, modeType] = path;
          const oldFlag = initial?.[modeType]?.is_enable;
          const newFlag = allValues?.[productName]?.[modeType]?.is_enable;

          const slabChanged = oldFlag !== newFlag;

          if (!slabChanged) {
            changedSlabsRef.current = changedSlabsRef.current.filter((s) => s.key !== IS_ENABLE);
            return;
          }
          const target = ensurePath(changedSlabsRef.current, [productName, modeType]);
          target.is_enable = {
            oldValue: oldFlag,
            newValue: newFlag
          };
        }
        if (path?.length === 6) {
          const [productName, modeType, categoryKey, typeKey, cardBrand, slabKey] = path;
          const newSlab =
            allValues?.[productName]?.[modeType]?.[categoryKey]?.[typeKey]?.[cardBrand]?.[slabKey];
          let oldSlab;
          if (cardBrand == FIRST) {
            oldSlab = initial?.[modeType]?.[categoryKey]?.[typeKey]?.[slabKey];
          } else {
            oldSlab = initial?.[modeType]?.[categoryKey]?.[typeKey]?.[cardBrand]?.[slabKey];
          }

          const slabChanged = Object.keys(newSlab).some((field) => {
            if (newSlab[field] === undefined) return false;
            return newSlab[field] !== oldSlab[field];
          });
          if (!slabChanged) {
            const slabs =
              changedSlabsRef.current?.[productName]?.[modeType]?.[categoryKey]?.[typeKey];
            const brandObj = slabs?.[cardBrand];
            if (brandObj && Object.prototype.hasOwnProperty.call(brandObj, slabKey)) {
              delete brandObj[slabKey];
            }
            return;
          }
          const target = ensurePath(changedSlabsRef.current, [
            productName,
            modeType,
            categoryKey,
            typeKey,
            cardBrand,
            slabKey
          ]);

          target.oldValue = oldSlab;
          target.newValue = newSlab;
        }
      });

      setChangedSlabLength(changedSlabsRef?.current);
    };

    findChangedSlabs(changedValues);
  };

  return (
    <Form
      form={commercialForm}
      onValuesChange={(changedValues, allValues) => handleFormChange(changedValues, allValues)}
    >
      <CardWrapper
        title={
          <Typography.Text style={{ fontSize: '20px', fontWeight: '500' }}>
            {product} Commercial Configuration
          </Typography.Text>
        }
        extra={
          <CommercialActions
            product={product}
            toggleDisableField={toggleDisableField}
            changedSlabLength={changedSlabLength}
            handleCommissionCalculatorModal={handleCommissionCalculatorModal}
            handleRequestChange={handleRequestChange}
            hanldeRevisionModal={hanldeRevisionModal}
            confirmRevisisionModal={confirmRevisisionModal}
            hanldeOnCancelRequest={hanldeOnCancelRequest}
            handleFormSubmit={handleFormSubmit}
            loading={loading}
            isRequestMarkupAllowed={isRequestMarkupAllowed}
          />
        }
      >
        <PaymentModeTabs
          defaultActiveKey="1"
          size="large"
          items={configsItems}
          tabPosition="left"
          renderTabBar={renderTabBarPayment}
        />
        <MetaWrapper description="*All rates are exclusive of GST. The above numbers are reflective of the true value." />
      </CardWrapper>
      <ModalWrapper
        width="490px"
        className="custom-modal"
        title={
          <Typography.Text
            style={{
              fontSize: '20px',
              fontWeight: '500',
              width: '100%',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            Request Raised Successfully!
          </Typography.Text>
        }
        centered
        open={raiseRequest}
        closable
        onCancel={() => handleRaiseRequestModal(false)}
        footer={null}
      >
        <Space
          style={{
            textAlign: 'center'
          }}
        >
          <Typography.Text
            style={{
              fontSize: '16px',
              width: '100%'
            }}
          >
            The request to change the rates has been raised successfully. Our team will get back to
            you shortly
          </Typography.Text>
        </Space>
      </ModalWrapper>

      <CommissionCalculator
        commissionModalOpen={commissionModalOpen}
        handleCommissionDrawerClose={handleCommissionCalculatorModal}
        markupInitialValue={configuration}
        transactionAmountForm={transactionAmountForm}
        product={product}
      />
    </Form>
  );
}
ProductTemplate.propTypes = {
  product: PropTypes.string.isRequired,
  configuration: PropTypes.instanceOf(Array).isRequired,
  initial: PropTypes.instanceOf(Object).isRequired,
  isRequestMarkupAllowed: PropTypes.bool.isRequired
};

export default ProductTemplate;
